// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase.js";
import { doc, getDoc, setDoc } from "firebase/firestore";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (fbUser) => {
      if (fbUser) {
        // referência ao documento de usuário
        const userRef = doc(db, "users", fbUser.uid);
        // tenta obter o documento
        let snap = await getDoc(userRef);
        // se não existir, cria com os dados básicos
        if (!snap.exists()) {
          await setDoc(userRef, {
            uid: fbUser.uid,
            displayName: fbUser.displayName || "",
            email: fbUser.email,
            isAdmin: false
          });
          // refaz o get para popular eventual data
          snap = await getDoc(userRef);
        }
        const data = snap.exists() ? snap.data() : {};
        // atualiza estado com dados combinados Auth + Firestore
        setUser({
          uid: fbUser.uid,
          email: fbUser.email,
          displayName: data.displayName || fbUser.displayName || "",
          isAdmin: data.isAdmin || false,
          isClientManager: data.isClientManager || false
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading }}>
      {children}
    </AuthContext.Provider>
  );
}
